import React from "react";
import {connect} from "react-redux";
import {API_URL} from "../../constants";
import {RoomModal} from "./RoomModal";
import {addRoom} from "../../redux/actions";

class RoomCreateModal extends RoomModal {
    constructor(props) {
        super(props);

        this.editMode = false;
        this.title = 'Add room';

        this.state = {
            formData: this.initialFormData(),
            alertShow: false,
            alertMessage: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    initialFormData() {
        return {
            dateCheckBoxes: {}, // Object like {dateString: boolean} which controls date selection checkboxes.
        };
    }

    async handleSave() {
        const {formData} = this.state;

        // Put selected dates in a list
        const datesAvailable = [];
        for (const dateStr in formData.dateCheckBoxes)
            if (formData.dateCheckBoxes[dateStr])
                datesAvailable.push(dateStr);

        // Build data object to send
        const data = {
            name: formData.name,
            location: formData.location,
            dates_available: datesAvailable
        };

        let response = await fetch(API_URL + '/rooms', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data),
        });
        if (!response.ok && response.status !== 422) this.showAlert(response.statusText);
        else {
            let result = await response.json();
            if (response.status === 422) this.showAlert(result.message);
            else {
                /* Store room */
                this.props.addRoom(result.data);

                /* Close modal window */
                this.handleClose();
            }
        }
    }
}

export default connect(
    null,
    {addRoom}
)(RoomCreateModal);
